<template>
  <div></div>
</template>

<script>
import API from "../../../config/api";
export default {
  name: "RedirectToCreate",
  data() {
    return {
      companyId: '',
      role: '',
      userId: '',
    }
  },
  mounted() {
    this.companyId = window.localStorage.getItem("companyId");
    this.userId = window.localStorage.getItem("userid");
    this.role = window.localStorage.getItem("companyRoleType");
    this.gointo();
  },
  methods: {
    //进入公司看项目
    gointo() {
      if(!(window.localStorage.getItem("companyId"))){
        console.log
        this.$router.push({path: '/pages/userCenter/UserCenter'})
      }
      if (this.role == 0) {
        this.$router.push({path: '/pages/MainOperatePage', query: {companyId: this.companyId}})
      }
      if (this.role == 1) {
        this.getProductUserList()
      }
    },
    //获取用户已有的界面权限
    getProductUserList() {
      let self = this;
      //加一个接口通过userId获取到已经添加权限页面的名字
      let header1 = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data1 = {
        companyId: this.companyId,
        productUserId: this.userId, //登陆者自身
      }

      this.$axiosRequest({
        url: API.getProductUserList,
        method: 'POST',
        data: data1,
        header: header1,
        success: res => {
          console.log(res)
          let userCanRead = res.data["productUserList"];
          if (userCanRead.length !== 0)
            this.canReadId = userCanRead[0].productId;
          if (userCanRead.length === 0)
            this.canReadId = null;
          if (this.canReadId != null) {
            self.$router.push({
              path: '/pages/redirect/create',
              query: {companyId: self.companyId, editType: "3", productId: self.canReadId}
            })
          }
          if (this.canReadId == null) {
            console.log(this.canReadId)
            self.$message({type: 'success', message: '暂无分配的主页面'});
            self.$router.push({path: '/pages/userCenter/UserCenter'})
          }

        }
      });
    }
  }
}
</script>

<style scoped>

</style>